import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from "@nu-art/permissions-shared/consts";
export const PermissionKey_SmartDocView = 'permission-key--smart-doc-view';
export const PermissionKey_SmartDocEdit = 'permission-key--smart-doc-edit';
export const PermissionKey_SmartDocDelete = 'permission-key--smart-doc-delete';
export const SmartDocPermissionKeys = {
    view: PermissionKey_SmartDocView,
    delete: PermissionKey_SmartDocEdit,
    edit: PermissionKey_SmartDocDelete,
};
export const DomainNamespace_SmartDoc = 'SmartDoc';
export const DomainNamespace_SmartDocEditor = 'Smart Doc Editor';
export const SmartDocEditorPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_SmartDocEditor, defaultUIAccessLevels);
//# sourceMappingURL=permissions.js.map